import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/loginNew/loginNew.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      meta: { isLogin: false },
      redirect: '/login'
    }, {
      path: '/appPrivacy',
      meta: { isLogin: false, title: '隐私条款' },
      component: resolve => require(['@/views/app/appPrivacy'], resolve)
    }, {
      path: '/productPreview',
      name: 'productPreview',
      meta: { isLogin: true, title: '产品预览' },
      component: resolve => require(['@/views/product/widget/preview'], resolve)
    }, {
      path: '/productNoPreview',
      name: 'productNoPreview',
      meta: { isLogin: true, title: '产品编号预览' },
      component: resolve => require(['@/views/product/widget/preview/productNoPreview'], resolve)
    }, {
      path: '/login',
      name: 'login',
      meta: { isLogin: false, title: '登录' },
      component: login // resolve => require(['@/views/login/login.vue'], resolve)
    }, {
      path: '/publicNotice',
      name: 'publicNotice',
      meta: { isLogin: false, title: '通告详情' },
      component: resolve => require(['@/views/login/second/publicNotice.vue'], resolve)
    }, {
      path: '/selectMerchantType',
      name: 'selectMerchantType',
      meta: { isLogin: false, title: '选择用户类型' },
      component: resolve => require(['@/views/login/selectMerchantType.vue'], resolve)
    }, {
      path: '/backAccount',
      name: 'backAccount',
      meta: { isLogin: false, title: '找回账号和密码' },
      component: resolve => require(['@/views/login/backAccount.vue'], resolve)
    }, {
      path: '/backAccountMsg',
      name: 'backAccountMsg',
      meta: { isLogin: false, title: '找回账号和密码' },
      component: resolve => require(['@/views/login/backAccountMsg.vue'], resolve)
    }, {
      path: '/register',
      name: 'register',
      meta: { isLogin: false, title: '注册' },
      component: resolve => require(['@/views/login/register.vue'], resolve),
      data: { isRegister: true }
    }, {
      path: '/counterInfo',
      name: 'counterInfo',
      meta: { isLogin: false, title: '柜台信息' },
      component: resolve => require(['@/views/system/counterInfo.vue'], resolve)
    }, {
      path: '/supplement',
      name: '/supplement',
      meta: { isLogin: false, title: '使用流程补充' },
      component: resolve => require(['@/views/product/second/supplement.vue'], resolve)
    }, {
      path: '/barCode',
      name: 'barCode',
      meta: { isLogin: false, title: '二维码链接', content: 'width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no' },
      component: resolve => require(['@/views/barcode/barCode.vue'], resolve)
    }, {
      path: '/payResult',
      name: 'payResult',
      meta: { isLogin: false, title: '支付结果', content: 'width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no' },
      component: resolve => require(['@/views/pay/payResult.vue'], resolve)
    }, {
      path: '/newHomePage',
      name: 'newHomeHomepage',
      meta: { isLogin: true, title: '首页' },
      component: resolve => require(['@/views/newHome/homepage/index.vue'], resolve)
    }, {
      path: '/newProductList',
      name: 'newHomeProductList',
      meta: { isLogin: true, title: '产品列表' },
      component: resolve => require(['@/views/newHome/product-list/index.vue'], resolve)
    }, {
      path: '/sysHome',
      meta: { isLogin: true, title: '主页' },
      component: resolve => require(['@/components/home.vue'], resolve),
      children: [
        {
          path: '/',
          name: 'sysHome',
          meta: { isLogin: true, title: '系统首页' },
          component: resolve => require(['@/views/sysHome/index'], resolve)
        },
        {
          path: '/bulkPurchaseList',
          name: 'bulkPurchaseList',
          meta: { isLogin: true, title: '批量采购列表' },
          component: resolve => require(['@/views/entityTicket/bulkPurchaseList.vue'], resolve)
        },
        {
          path: '/submitAndPayOrderBatch',
          name: 'submitAndPayOrderBatch',
          meta: { isLogin: true, title: '批量采购' },
          component: resolve => require(['@/views/entityTicket/submitAndPayOrderBatch.vue'], resolve)
        },
        {
          path: '/bulkPurchaseDetail',
          name: 'bulkPurchaseDetail',
          meta: { isLogin: true, title: '批量采购详情' },
          component: resolve => require(['@/views/entityTicket/bulkPurchaseDetail.vue'], resolve)
        },
        {
          path: '/productList',
          name: 'productList',
          meta: { isLogin: true, title: '产品列表' },
          component: resolve => require(['@/views/product/productList.vue'], resolve)
        },
        {
          path: '/releaseProducts',
          name: 'releaseProducts',
          meta: { isLogin: true, title: '发布产品' },
          component: resolve => require(['@/views/product/releaseProducts.vue'], resolve)
        },
        // {
        //   path: '/releaseThirdProducts',
        //   name: 'releaseThirdProducts',
        //   meta: {isLogin: true, title: '发布第三方产品'},
        //   component: resolve => require(['@/views/product/releaseThirdProducts.vue'], resolve)
        // },
        {
          path: '/supplyManageProduct',
          name: 'supplyManageProduct',
          meta: { isLogin: true, title: '产品售卖管理' },
          component: resolve => require(['@/views/product/supplyManageProduct.vue'], resolve)
        }, {
          path: '/tocDistributorManageProduct',
          name: 'tocDistributorManageProduct',
          meta: { isLogin: true, title: 'TOC产品售卖管理' },
          component: resolve => require(['@/views/product/tocDistributorManageProduct.vue'], resolve)
        }, {
          path: '/importThirdSystemProduct',
          name: 'importThirdSystemProduct',
          meta: { isLogin: true, title: '产品售卖管理' },
          component: resolve => require(['@/views/product/importThirdSystemProduct.vue'], resolve)
        },
        {
          path: '/productAuditing',
          name: 'productAuditing',
          meta: { isLogin: true, title: '产品审核列表' },
          component: resolve => require(['@/views/product/productAuditing.vue'], resolve)
        },
        {
          path: '/productPriceNumber',
          name: 'productPriceNumber',
          meta: { isLogin: true, title: '价格库存' },
          component: resolve => require(['@/views/product/productPriceNumber.vue'], resolve)
        },
        {
          path: '/orderManagement',
          name: 'orderManagement',
          meta: { isLogin: true, title: '订单管理' },
          component: resolve => require(['@/views/order/supplyOrderMagn.vue'], resolve)
        },
        {
          path: '/distriOrderMagnToC',
          name: 'distriOrderMagnToC',
          meta: { isLogin: true, title: '订单管理' },
          component: resolve => require(['@/views/order/distriOrderMagnToC.vue'], resolve)
        },
        {
          path: '/operatorOrderManagement',
          name: 'operatorOrderManagement',
          meta: { isLogin: true, title: '运营商订单管理' },
          component: resolve => require(['@/views/order/operatorOrderMagn.vue'], resolve)
        },
        {
          path: '/supplyOrderDetail',
          name: 'supplyOrderDetail',
          meta: { isLogin: true, title: '供应商订单详情' },
          component: resolve => require(['@/views/order/second/supplyOrderDetail.vue'], resolve)
        },
        {
          path: '/jtrSupplyOrderDetail',
          name: 'jtrSupplyOrderDetail',
          meta: { isLogin: true, title: '供应商订单详情(JTR)' },
          component: resolve => require(['@/views/order/second/jtrSupplyOrderDetail.vue'], resolve)
        },
        {
          path: '/distriOrderDetail',
          name: 'distriOrderDetail',
          meta: { isLogin: true, title: '分销商订单详情' },
          component: resolve => require(['@/views/order/second/distriOrderDetail.vue'], resolve)
        },
        {
          path: '/distriOrderToCDetail',
          name: 'distriOrderToCDetail',
          meta: { isLogin: true, title: 'TOC分销商订单详情' },
          component: resolve => require(['@/views/order/second/distriOrderToCDetail.vue'], resolve)
        },
        {
          path: '/operatorOrderDetail',
          name: 'operatorOrderDetail',
          meta: { isLogin: true, title: '运营商订单详情' },
          component: resolve => require(['@/views/order/second/operatorOrderDetail.vue'], resolve)
        },
        {
          path: '/jtrOrderDetail',
          name: 'jtrOrderDetail',
          meta: { isLogin: true, title: '运营商JTR订单详情' },
          component: resolve => require(['@/views/order/second/jtrOrderDetail.vue'], resolve)
        },
        {
          path: '/jtrOrderDetailOperative',
          name: 'jtrOrderDetailOperative',
          meta: { isLogin: true, title: '运营商JTR订单详情Operative' },
          component: resolve => require(['@/views/order/second/jtrOrderDetailOperative.vue'], resolve)
        },
        {
          path: '/distriJtrOrderToCDetail',
          name: 'distriJtrOrderToCDetail',
          meta: { isLogin: true, title: '分销商订单详情' },
          component: resolve => require(['@/views/order/second/distriJtrOrderToCDetail.vue'], resolve)
        },
        {
          path: '/distriJtrOrderDetail',
          name: 'distriJtrOrderDetail',
          meta: { isLogin: true, title: '分销商订单详情' },
          component: resolve => require(['@/views/order/second/distriJtrOrderDetail.vue'], resolve)
        },
        {
          path: '/jtrcancel',
          name: 'jtrcancel',
          meta: { isLogin: true, title: '部分取消' },
          component: resolve => require(['@/views/jtrprocurement/second/jtrcancel.vue'], resolve)
        },
        {
          path: '/distributor',
          name: 'distributor',
          meta: { isLogin: true, title: '分销商管理' },
          component: resolve => require(['@/views/merchant/distributor.vue'], resolve)
        },
        {
          path: '/balance',
          name: 'balance',
          meta: { isLogin: true, title: '分销商管理余额设置' },
          component: resolve => require(['@/views/merchant/balance.vue'], resolve)
        },
        {
          path: '/supplier',
          name: 'supplier',
          meta: { isLogin: true, title: '供应商管理' },
          component: resolve => require(['@/views/merchant/supplier.vue'], resolve)
        },
        {
          path: '/withdrawal',
          name: 'withdrawal',
          meta: { isLogin: true, title: '提现管理' },
          component: resolve => require(['@/views/recharge/withdrawal.vue'], resolve)
        },
        {
          path: '/operatorWithdrawal',
          name: 'operatorWithdrawal',
          meta: { isLogin: true, title: '充值/提现管理' },
          component: resolve => require(['@/views/recharge/operatorWithdrawal.vue'], resolve)
        },
        {
          path: '/recharge',
          name: 'recharge',
          meta: { isLogin: true, title: '充值管理' },
          component: resolve => require(['@/views/recharge/recharge.vue'], resolve)
        },
        {
          path: '/onlineRecharge',
          name: 'onlineRecharge',
          meta: { isLogin: true, title: '在线充值' },
          component: resolve => require(['@/views/recharge/onlineRecharge.vue'], resolve)
        },
        {
          path: '/pay/return',
          name: 'payReturn',
          meta: { isLogin: true, title: '回调显示页面' },
          component: resolve => require(['@/views/recharge/payReturn.vue'], resolve)
        },
        {
          path: '/trades',
          name: 'trades',
          meta: { isLogin: true, title: '交易明细' },
          component: resolve => require(['@/views/recharge/trades.vue'], resolve)
        },
        {
          path: '/record',
          name: 'record',
          meta: { isLogin: true, title: '充值提现记录' },
          component: resolve => require(['@/views/recharge/record.vue'], resolve)
        },
        {
          path: '/scenicSpotList',
          name: 'scenicSpotList',
          meta: { isLogin: true, title: '景点列表' },
          component: resolve => require(['@/views/scenicSpot/scenicSpotList.vue'], resolve)
        },
        {
          path: '/banner',
          name: 'banner',
          meta: { isLogin: true, title: 'banner管理' },
          component: resolve => require(['@/views/banner/banner.vue'], resolve)
        },
        {
          path: '/popularCities',
          name: 'popularCities',
          meta: { isLogin: true, title: '热门城市管理' },
          component: resolve => require(['@/views/popularCities/popularCitiesList.vue'], resolve)
        },
        {
          path: '/addPopularCities',
          name: 'addPopularCities',
          meta: { isLogin: true, title: '新增热门城市' },
          component: resolve => require(['@/views/popularCities/addPopularCities.vue'], resolve)
        },
        {
          path: '/recommendedAttractions',
          name: 'recommendedAttractions',
          meta: { isLogin: true, title: '首页推荐管理' },
          component: resolve => require(['@/views/recommendedAttractions/addRecommendedAttractions.vue'], resolve)
        },
        {
          path: '/financeStatement',
          name: 'financeStatement',
          meta: { isLogin: true, title: '财务报表' },
          component: resolve => require(['@/views/finance/financeStatement.vue'], resolve)
        },
        {
          path: '/ActuarialManagement',
          name: 'ActuarialManagement',
          meta: { isLogin: true, title: '精算管理' },
          component: resolve => require(['@/views/finance/ActuarialManagement.vue'], resolve)
        },
        {
          path: '/ActuarialManagementDetail',
          name: 'ActuarialManagementDetail',
          meta: { isLogin: true, title: '精算管理' },
          component: resolve => require(['@/views/finance/second/ActuarialManagementDetail.vue'], resolve)
        },
        {
          path: '/statementDetail',
          name: 'statementDetail',
          meta: { isLogin: true, title: '报表详情' },
          component: resolve => require(['@/views/finance/second/statementDetail.vue'], resolve)
        },
        {
          path: '/setQrCode',
          name: 'setQrCode',
          meta: { isLogin: true, title: '设置二维码' },
          component: resolve => require(['@/views/product/setQrCode.vue'], resolve)
        },
        {
          path: '/applyDistribution',
          name: 'applyDistribution',
          meta: { isLogin: true, title: '分销审核' },
          component: resolve => require(['@/views/product/applyDistribution.vue'], resolve)
        },
        {
          path: '/revenueManagement',
          name: 'revenueManagement',
          meta: { isLogin: true, title: '收益管理(分销toc)' },
          component: resolve => require(['@/views/product/revenueManagement.vue'], resolve)
        },
        {
          path: '/revenueDetail',
          name: 'revenueDetail',
          meta: { isLogin: true, title: '收益详情(分销toc)' },
          component: resolve => require(['@/views/product/revenueDetail.vue'], resolve)
        },
        {
          path: '/applyCash',
          name: 'applyCash',
          meta: { isLogin: true, title: '提现管理(分销toc)' },
          component: resolve => require(['@/views/product/applyCash.vue'], resolve)
        },
        {
          path: '/operatApplyCash',
          name: 'operatApplyCash',
          meta: { isLogin: true, title: '提现管理(运营商)' },
          component: resolve => require(['@/views/product/operatApplyCash.vue'], resolve)
        },
        {
          path: '/coupon',
          name: 'coupon',
          meta: { isLogin: true, title: 'ToC优惠券管理' },
          component: resolve => require(['@/views/product/coupon.vue'], resolve)
        },
        {
          path: '/couponOrder',
          name: 'couponOrder',
          meta: { isLogin: true, title: '优惠券订单' },
          component: resolve => require(['@/views/product/couponOrder.vue'], resolve)
        },
        {
          path: '/operatorOrderMagnToC',
          name: 'operatorOrderMagnToC',
          meta: { isLogin: true, title: '运营商订单管理(toc)' },
          component: resolve => require(['@/views/order/operatorOrderMagnToC.vue'], resolve)
        },
        {
          path: '/QrCodeAndproductDetail',
          name: 'QrCodeAndproductDetail',
          meta: { isLogin: true, title: '二维码与产品' },
          component: resolve => require(['@/views/product/QrCodeAndproductDetail.vue'], resolve)
        },
        {
          path: '/couponDetail',
          name: 'couponDetail',
          meta: { isLogin: true, title: '优惠券详情' },
          component: resolve => require(['@/views/product/couponDetail.vue'], resolve)
        },
        {
          path: '/AddRequestForPayment',
          name: 'AddRequestForPayment',
          meta: { isLogin: true, title: '请款书支付' },
          component: resolve => require(['@/views/finance/second/AddRequestForPayment.vue'], resolve)
        },
        {
          path: '/ChooseAddActuary',
          name: 'ChooseAddActuary',
          meta: { isLogin: true, title: '选择新增精算类型' },
          component: resolve => require(['@/views/finance/ChooseAddActuary.vue'], resolve)
        },
        {
          path: '/AddTemporaryPurchase',
          name: 'AddTemporaryPurchase',
          meta: { isLogin: true, title: '临时采购' },
          component: resolve => require(['@/views/finance/second/AddTemporaryPurchase.vue'], resolve)
        },
        {
          path: '/adminAccount',
          name: 'adminAccount',
          meta: { isLogin: true, title: '管理员账号' },
          component: resolve => require(['@/views/system/adminAccount.vue'], resolve)
        },
        {
          path: '/noticeManager',
          name: 'noticeManager',
          meta: { isLogin: true, title: '通告管理' },
          component: resolve => require(['@/views/system/notice.vue'], resolve)
        },
        {
          path: '/noticeDetails',
          name: 'noticeDetails',
          meta: { isLogin: true, title: '通告详情' },
          component: resolve => require(['@/views/sysHome/second/noticeDetails.vue'], resolve)
        },
        {
          path: '/addNotice',
          name: 'addNotice',
          meta: { isLogin: true, title: '添加通告' },
          component: resolve => require(['@/views/system/second/addNotice.vue'], resolve)
        },
        {
          path: '/pwdSet',
          name: 'pwdSet',
          meta: { isLogin: true, title: '密码设置' },
          component: resolve => require(['@/views/system/pwdSet.vue'], resolve)
        },
        {
          path: '/payType',
          name: 'payType',
          meta: { isLogin: true, title: '支付方式' },
          component: resolve => require(['@/views/system/payType.vue'], resolve)
        },
        {
          path: '/merchantInfo',
          name: 'merchantInfo',
          meta: { isLogin: true, title: '商户信息' },
          component: resolve => require(['@/views/system/merchantInfo.vue'], resolve)
        },
        {
          path: '/clerk',
          name: 'clerk',
          meta: { isLogin: true, title: '业务员管理' },
          component: resolve => require(['@/views/system/clerk.vue'], resolve)
        },
        {
          path: '/exportRules',
          name: 'exportRules',
          meta: { isLogin: true, title: '导出规则一览' },
          component: resolve => require(['@/views/system/exportRules.vue'], resolve)
        },
        {
          path: '/exportSetting',
          name: 'exportSetting',
          meta: { isLogin: true, title: '导出项目设置' },
          component: resolve => require(['@/views/system/exportSetting.vue'], resolve)
        },
        {
          path: '/addClerk',
          name: 'addClerk',
          meta: { isLogin: true, title: '添加业务员' },
          component: resolve => require(['@/views/system/second/addClerk.vue'], resolve)
        },
        {
          path: '/operator',
          name: 'operator',
          meta: { isLogin: true, title: '管理员管理' },
          component: resolve => require(['@/views/system/operator.vue'], resolve)
        },
        {
          path: '/addOperator',
          name: 'addOperator',
          meta: { isLogin: true, title: '添加管理员' },
          component: resolve => require(['@/views/system/second/addOperator.vue'], resolve)
        },
        {
          path: '/updatePayType',
          name: 'updatePayType',
          meta: { isLogin: true, title: '修改支付方式' },
          component: resolve => require(['@/views/system/second/updatePayType.vue'], resolve)
        },
        {
          path: '/liaisons',
          name: 'liaisons',
          meta: { isLogin: true, title: '联络人管理' },
          component: resolve => require(['@/views/system/liaisons.vue'], resolve)
        },
        {
          path: '/addLiaisons',
          name: 'addLiaisons',
          meta: { isLogin: true, title: '添加联络人' },
          component: resolve => require(['@/views/system/second/addLiaisons.vue'], resolve)
        },
        {
          path: '/counter',
          name: 'counter',
          meta: { isLogin: true, title: '柜台管理' },
          component: resolve => require(['@/views/system/counter.vue'], resolve)
        },
        {
          path: '/addCounter',
          name: 'addCounter',
          meta: { isLogin: true, title: '添加柜台' },
          component: resolve => require(['@/views/system/second/addCounter.vue'], resolve)
        },
        {
          path: '/newOrderEmail',
          name: 'newOrderEmail',
          meta: { isLogin: true, title: '新订单邮件通知设置' },
          component: resolve => require(['@/views/system/newOrderEmail.vue'], resolve)
        },
        {
          path: '/reserve',
          name: 'reserve',
          meta: { isLogin: true, title: '产品预定' },
          component: resolve => require(['@/views/procurement/reserve.vue'], resolve)
        }, {
          path: '/jtrreserve',
          name: 'jtrreserve',
          meta: { isLogin: true, title: 'JTR产品预定' },
          component: resolve => require(['@/views/jtrprocurement/jtrreserve.vue'], resolve)
        },
        {
          path: '/confirmOrder',
          name: 'confirmOrder',
          meta: { isLogin: true, title: '提交订单' },
          component: resolve => require(['@/views/procurement/second/confirmOrder.vue'], resolve)
        },
        {
          path: '/jtrconfirmOrder',
          name: 'jtrconfirmOrder',
          meta: { isLogin: true, title: '提交订单' },
          component: resolve => require(['@/views/jtrprocurement/second/jtrconfirmOrder.vue'], resolve)
        },
        {
          path: '/klookConfirmOrder',
          name: 'klookConfirmOrder',
          meta: { isLogin: true, title: '提交订单' },
          component: resolve => require(['@/views/procurement/second/klookConfirmOrder.vue'], resolve)
        },
        {
          path: '/jtrConfirmOrderNew',
          name: 'jtrConfirmOrderNew',
          meta: { isLogin: true, title: '提交订单' },
          component: resolve => require(['@/views/procurement/second/jtrConfirmOrder.vue'], resolve)
        },
        {
          path: '/payOrder',
          name: 'payOrder',
          meta: { isLogin: true, title: '支付订单' },
          component: resolve => require(['@/views/procurement/second/payOrder.vue'], resolve)
        },
        {
          path: '/jtrpayOrderState',
          name: 'jtrpayOrderState',
          meta: { isLogin: true, title: 'jtr支付订单' },
          component: resolve => require(['@/views/jtrprocurement/second/jtrpayOrderState.vue'], resolve)
        },
        {
          path: '/distriOrderMagn',
          name: 'distriOrderMagn',
          meta: { isLogin: true, title: '订单管理' },
          component: resolve => require(['@/views/order/distriOrderMagn.vue'], resolve)
        },
        {
          path: '/userDepot',
          name: 'userDepot',
          meta: { isLogin: true, title: '用户仓库管理' },
          component: resolve => require(['@/views/entityTicket/userDepot.vue'], resolve)
        },
        {
          path: '/warehouse',
          name: 'warehouse',
          meta: { isLogin: true, title: '仓库管理' },
          component: resolve => require(['@/views/entityTicket/warehouse.vue'], resolve)
        },
        {
          path: '/ticketDepot',
          name: 'ticketDepot',
          meta: { isLogin: true, title: '票仓一览' },
          component: resolve => require(['@/views/entityTicket/second/ticketDepot.vue'], resolve)
        },
        {
          path: '/addTicketDepot',
          name: 'addTicketDepot',
          meta: { isLogin: true, title: '新增票仓' },
          component: resolve => require(['@/views/entityTicket/second/addTicketDepot.vue'], resolve)
        },
        {
          path: '/importTicket',
          name: 'importTicket',
          meta: { isLogin: true, title: '实体票入仓' },
          component: resolve => require(['@/views/entityTicket/second/importTicket.vue'], resolve)
        },
        {
          path: '/ticketBatchList',
          name: 'ticketBatchList',
          meta: { isLogin: true, title: '实体票批次一览' },
          component: resolve => require(['@/views/entityTicket/second/ticketBatchList.vue'], resolve)
        },
        {
          path: '/pinTicket',
          name: 'pinTicket',
          meta: { isLogin: true, title: '验证销票' },
          component: resolve => require(['@/views/entityTicket/pinTicket.vue'], resolve)
        },
        {
          path: '/shortcutOut',
          name: 'shortcutOut',
          meta: { isLogin: true, title: '快捷销票' },
          component: resolve => require(['@/views/entityTicket/shortcutOut.vue'], resolve)
        },
        {
          path: '/pinTicketMagn',
          name: 'pinTicketMagn',
          meta: { isLogin: true, title: '验证销票管理' },
          component: resolve => require(['@/views/entityTicket/pinTicketMagn.vue'], resolve)
        },
        {
          path: '/pdfFiles',
          name: 'pdfFiles',
          meta: { isLogin: true, title: 'PDF文件库管理' },
          component: resolve => require(['@/views/e_ticket/pdfFiles.vue'], resolve)
        },
        {
          path: '/batchList',
          name: 'batchList',
          meta: { isLogin: true, title: '批次列表' },
          component: resolve => require(['@/views/e_ticket/second/batchList.vue'], resolve)
        },
        {
          path: '/batchPdfFilesList',
          name: 'batchPdfFilesList',
          meta: { isLogin: true, title: '批次文件列表' },
          component: resolve => require(['@/views/e_ticket/second/batchPdfFilesList.vue'], resolve)
        },
        {
          path: '/addPdfFiles',
          name: 'addPdfFiles',
          meta: { isLogin: true, title: '添加PDF文件库' },
          component: resolve => require(['@/views/e_ticket/second/addPdfFiles.vue'], resolve)
        },
        {
          path: '/importPdf',
          name: 'importPdf',
          meta: { isLogin: true, title: '导入PDF文件' },
          component: resolve => require(['@/views/e_ticket/second/importPdf.vue'], resolve)
        },
        {
          path: '/addProduct',
          name: 'addProduct',
          meta: { isLogin: true, title: '添加产品' },
          component: resolve => require(['@/views/product/second/addProduct.vue'], resolve)
        },
        {
          path: '/operateAddProduct',
          name: 'operateAddProduct',
          meta: { isLogin: true, title: '添加产品' },
          component: resolve => require(['@/views/product/second/operateAddProduct.vue'], resolve)
        },
        {
          path: '/jtrAddProduct',
          name: 'jtrAddProduct',
          meta: { isLogin: true, title: '添加产品' },
          component: resolve => require(['@/views/product/second/jtrAddProduct.vue'], resolve)
        },
        {
          path: '/klookAddProduct',
          name: 'klookAddProduct',
          meta: { isLogin: true, title: '添加产品' },
          component: resolve => require(['@/views/product/second/klookAddProduct.vue'], resolve)
        },
        {
          path: '/productDetail',
          name: 'productDetail',
          meta: { isLogin: true, title: '产品详情（实体票/电子票/体验）' },
          component: resolve => require(['@/views/product/second/productDetail.vue'], resolve)
        },
        {
          path: '/diningDetail',
          name: 'diningDetail',
          meta: { isLogin: true, title: '餐厅产品详情' },
          component: resolve => require(['@/views/product/second/diningDetail.vue'], resolve)
        },
        {
          path: '/tourDetail',
          name: 'tourDetail',
          meta: { isLogin: true, title: '一日游/多日游产品详情' },
          component: resolve => require(['@/views/product/second/tourDetail.vue'], resolve)
        },
        {
          path: '/WIFIDetail',
          name: 'WIFIDetail',
          meta: { isLogin: true, title: 'WIFI产品详情' },
          component: resolve => require(['@/views/product/second/WIFIDetail.vue'], resolve)
        },
        {
          path: '/SIMDetail',
          name: 'SIMDetail',
          meta: { isLogin: true, title: 'SIM卡产品详情' },
          component: resolve => require(['@/views/product/second/SIMDetail.vue'], resolve)
        },
        {
          path: '/trafficDetail',
          name: 'trafficDetail',
          meta: { isLogin: true, title: '交通产品详情' },
          component: resolve => require(['@/views/product/second/trafficDetail.vue'], resolve)
        },
        {
          path: '/productPackageDetail',
          name: 'productPackageDetail',
          meta: { isLogin: true, title: '套餐详情' },
          component: resolve => require(['@/views/product/second/productPackageDetail.vue'], resolve)
        },
        {
          path: '/jtrTicketDetail',
          name: 'jtrTicketDetail',
          meta: { isLogin: true, title: 'JTR门票详情' },
          component: resolve => require(['@/views/product/second/jtrTicketDetail.vue'], resolve)
        },
        {
          path: '/klookProductDetail',
          name: 'klookProductDetail',
          meta: { isLogin: true, title: 'JTR门票详情' },
          component: resolve => require(['@/views/product/second/klookProductDetail.vue'], resolve)
        },
        {
          path: '/addScenicSpot',
          name: 'addScenicSpot',
          meta: { isLogin: true, title: '追加景点' },
          component: resolve => require(['@/views/scenicSpot/addScenicSpot.vue'], resolve)
        },
        {
          path: '/merchantAudit',
          name: 'merchantAudit',
          meta: { isLogin: true, title: '供应商/分销商管理' },
          component: resolve => require(['@/views/merchant/merchantAudit.vue'], resolve)
        },
        {
          path: '/editTest',
          name: 'editTest',
          meta: { isLogin: false, title: '富文本测试' },
          component: resolve => require(['@/views/product/editTest.vue'], resolve)
        },
        {
          path: '/pageSetting',
          name: 'pageSetting',
          meta: { isLogin: false, title: '登录图片更新' },
          component: resolve => require(['@/views/system/pageSetting.vue'], resolve)
        },
        {
          path: '/productLogList',
          name: 'productLogList',
          meta: { isLogin: true, title: '产品Log列表' },
          component: resolve => require(['@/views/product-log/productLogList.vue'], resolve)
        },
        {
          path: '/productLogDetail',
          name: 'productLogDetail',
          meta: { isLogin: true, title: '产品Log详情' },
          component: resolve => require(['@/views/product-log/second/productLogDetail.vue'], resolve)
        },
        {
          path: '/productLanguageLogDetail',
          name: 'productLanguageLogDetail',
          meta: { isLogin: true, title: '产品Log详情' },
          component: resolve => require(['@/views/product-log/second/productLanguageLogDetail.vue'], resolve)
        },
        {
          path: '/scheduleList',
          name: 'scheduleList',
          meta: { isLogin: true, title: '定时任务列表' },
          component: resolve => require(['@/views/schedule/scheduleList.vue'], resolve)
        },
        {
          path: '/addSchedule',
          name: 'addSchedule',
          meta: { isLogin: true, title: '添加定时任务' },
          component: resolve => require(['@/views/schedule/second/addSchedule.vue'], resolve)
        },
        {
          path: '/remind',
          name: 'remind',
          meta: { isLogin: true, title: '添加提醒' },
          component: resolve => require(['@/views/recharge/remind.vue'], resolve)
        },
        {
          path: '/secondaryAgent',
          name: 'secondaryAgent',
          meta: { isLogin: false, title: '二级代理' },
          component: resolve => require(['@/views/system/secondaryAgent.vue'], resolve)
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js